import { useTranslation } from "react-i18next";

const PartnershipOpportunities = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 ">
        {/* Header Section */}
        <div className="mb-10">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            {t("Partnership Opportunities")}
          </h1>
          <p className="text-gray-600 text-base md:text-lg mb-2">
            {t(
              "yslearn partners with businesses that want to provide industry-best digital skills training to their customers."
            )}
          </p>
          <p className="text-gray-600 text-base md:text-lg">
            {t("We offer multiple partnership models:")}
          </p>
        </div>

        {/* Partnership Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {/* Distributors Card */}
          <div className="border border-gray-200 rounded-lg shadow-sm overflow-hidden">
            <div className="bg-blue-50 p-4 flex items-center gap-3">
              <div className="text-blue-500">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-8 w-8"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                  <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                  <line x1="12" y1="22.08" x2="12" y2="12"></line>
                </svg>
              </div>
              <h2 className="text-xl font-semibold text-gray-800">
                {t("Distributors")}
              </h2>
            </div>
            <div className="p-6">
              <p className="mb-4 text-gray-700">
                {t("For companies with more than")}{" "}
                <span className="font-semibold">$10 million USD</span>{" "}
                {t("in annual sales")}
              </p>
              <p className="mb-3 text-gray-700">{t("You can expect:")}</p>
              <ul className="space-y-2 mb-6">
                <li className="flex items-start">
                  <span className="text-gray-700 mr-2">•</span>
                  <span className="text-gray-700">
                    {t("Market exclusivity")}
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="text-gray-700 mr-2">•</span>
                  <span className="text-gray-700">
                    {t("Stock and sell licenses")}
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="text-gray-700 mr-2">•</span>
                  <span className="text-gray-700">
                    {t("Fixed-transfer pricing")}
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="text-gray-700 mr-2">•</span>
                  <span className="text-gray-700">
                    {t("Lead-sharing agreements")}
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="text-gray-700 mr-2">•</span>
                  <span className="text-gray-700">
                    {t("Sales, delivery, and marketing support")}
                  </span>
                </li>
              </ul>
              <a
                href="#"
                className="text-blue-500 font-medium hover:text-blue-600 transition-colors"
              >
                {t("Contact Us")}
              </a>
            </div>
          </div>

          {/* Channel Partners Card */}
          <div className="border border-gray-200 rounded-lg shadow-sm overflow-hidden">
            <div className="bg-blue-50 p-4 flex items-center gap-3">
              <div className="text-blue-500">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-8 w-8"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                </svg>
              </div>
              <h2 className="text-xl font-semibold text-gray-800">
                {t("Channel Partners")}
              </h2>
            </div>
            <div className="p-6">
              <p className="mb-4 text-gray-700">
                {t("For companies with more than")}{" "}
                <span className="font-semibold">$5 million USD</span>{" "}
                {t("in annual sales")}
              </p>
              <p className="mb-3 text-gray-700">{t("You can expect:")}</p>
              <ul className="space-y-2 mb-6">
                <li className="flex items-start">
                  <span className="text-gray-700 mr-2">•</span>
                  <span className="text-gray-700">
                    {t("Market development")}
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="text-gray-700 mr-2">•</span>
                  <span className="text-gray-700">
                    {t("Revenue commitment")}
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="text-gray-700 mr-2">•</span>
                  <span className="text-gray-700">{t("Revenue share")}</span>
                </li>
                <li className="flex items-start">
                  <span className="text-gray-700 mr-2">•</span>
                  <span className="text-gray-700">
                    {t("Sales and delivery support")}
                  </span>
                </li>
              </ul>
              <a
                href="#"
                className="text-blue-500 font-medium hover:text-blue-600 transition-colors"
              >
                {t("Contact Us")}
              </a>
            </div>
          </div>

          {/* Resellers And Referrals Card */}
          <div className="border border-gray-200 rounded-lg shadow-sm overflow-hidden">
            <div className="bg-blue-50 p-4 flex items-center gap-3">
              <div className="text-blue-500">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-8 w-8"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                  <polyline points="3.29 7 12 12 20.71 7"></polyline>
                  <line x1="12" y1="22" x2="12" y2="12"></line>
                </svg>
              </div>
              <h2 className="text-xl font-semibold text-gray-800">
                {t("Resellers And Referrals")}
              </h2>
            </div>
            <div className="p-6">
              <p className="mb-4 text-gray-700">
                {t("For companies with more than")}{" "}
                <span className="font-semibold">$1 million USD</span>{" "}
                {t("in annual sales")}
              </p>
              <p className="mb-3 text-gray-700">{t("You can expect:")}</p>
              <ul className="space-y-2 mb-6">
                <li className="flex items-start">
                  <span className="text-gray-700 mr-2">•</span>
                  <span className="text-gray-700">
                    {t("Resell yslearn courses")}
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="text-gray-700 mr-2">•</span>
                  <span className="text-gray-700">
                    {t("Referral opportunities")}
                  </span>
                </li>
              </ul>
              <a
                href="#"
                className="text-blue-500 font-medium hover:text-blue-600 transition-colors"
              >
                {t("Contact Us")}
              </a>
            </div>
          </div>
        </div>

        {/* University Partnership Section */}
        <div className="border border-gray-200 rounded-lg p-6 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <div className="text-blue-500">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-10 w-10"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
                <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-800">
              {t("Are You a University Looking for Partnership Opportunities?")}
            </h3>
          </div>
          <a
            href="#"
            className="bg-blue-500 hover:bg-blue-600 !text-white font-medium py-2 px-6 rounded transition-colors whitespace-nowrap"
          >
            {t("Learn More")}
          </a>
        </div>
      </div>
    </div>
  );
};

export default PartnershipOpportunities;
